import { motion, useReducedMotion } from "framer-motion";

/**
 * PageTransition — a subtle, reduced-motion-aware enter animation applied to
 * each routed page so navigation between the dedicated pages feels continuous
 * (Emil: transform+opacity only, ease-out, <=500ms, motivated by wayfinding).
 * Enter-only (no exit) keeps the shared chrome stable and avoids layout jank.
 */
export const PageTransition = ({ children, className = "" }) => {
    const reduce = useReducedMotion();
    return (
        <motion.div
            className={className}
            initial={reduce ? { opacity: 0 } : { opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
        >
            {children}
        </motion.div>
    );
};

export default PageTransition;
